import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const ROTATE_MS = 6000;

/**
 * Auto-rotating "real client win" social proof card.
 * Pulls latest published posts from the blog CMS and surfaces one at a time.
 */
const FeaturedCaseStudy = () => {
  const [posts, setPosts] = useState([]);
  const [index, setIndex] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    fetch(`${API}/posts`)
      .then((r) => r.json())
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) setPosts(data.slice(0, 5));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (posts.length < 2) return undefined;
    const t = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setIndex((i) => (i + 1) % posts.length);
        setFading(false);
      }, 350);
    }, ROTATE_MS);
    return () => clearInterval(t);
  }, [posts.length]);

  if (posts.length === 0) return null;

  const current = posts[index];

  return (
    <Link
      to={`/resources/${current.slug}`}
      data-testid="featured-case-study"
      className="group mt-8 inline-flex items-center gap-4 rounded-2xl border border-white/15 bg-white/5 backdrop-blur-md px-5 py-4 max-w-xl hover:border-[#00BCE4]/60 hover:bg-white/10 transition-all duration-500"
    >
      <span className="flex-shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[#00BCE4]/15 text-[#00BCE4]">
        <Sparkles size={18} />
      </span>
      <span
        className={`flex-1 min-w-0 transition-opacity duration-300 ${fading ? 'opacity-0' : 'opacity-100'}`}
      >
        <span
          className="block text-[10px] font-semibold uppercase tracking-[2px] text-[#00BCE4]"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Real client win · {current.category}
        </span>
        <span
          className="block text-sm font-semibold text-white truncate"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {current.title}
        </span>
      </span>
      <ArrowRight
        size={16}
        className="flex-shrink-0 text-white/60 group-hover:text-[#00BCE4] group-hover:translate-x-1 transition-all duration-300"
      />
    </Link>
  );
};

export default FeaturedCaseStudy;
